import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ReportTemplates from './routes/ReportTemplates';
import CreateNewTemplate from './routes/CreateNewTemplate';
import EditTemplate from './routes/EditTemplate';
import CreateNewTemplateV2 from './routes/CreateNewTemplateV2';
import EditTemplateV2 from './routes/EditTemplateV2';
import ProgressReports from './routes/ProgressReports';
import ReportDetailsView from './routes/ProgressReports/routes/ReportDetailsView';
import ReportDetailsStudentView from './routes/ProgressReports/routes/ReportDetailsStudentView';

const ReportConfigurationLazy = React.lazy(
	() => import(/* webpackChunkName : 'ReportConfiguration' */ './components')
);

const ReportDetailsTemplateLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ReportDetailsTemplate' */ './routes/ProgressReports/routes/ReportDetailsTemplate/components'
		)
);

export default (store) => {
	return [
		{
			path: 'report-configure',
			element: (
				<AsyncLoading
					component={
						<ReportConfigurationLazy permission="CanViewProgressReports" />
					}
				/>
			),
			children: [ReportTemplates(store), ProgressReports(store)],
		},
		// CreateNewTemplate(store),
		// EditTemplate(store),
		CreateNewTemplateV2(store),
		EditTemplateV2(store),
		{
			element: (
				<AsyncLoading
					component={
						<ReportDetailsTemplateLazy permission="CanViewProgressReports" />
					}
				/>
			),
			children: [ReportDetailsView(store), ReportDetailsStudentView(store)],
		},
	];
};
